<template>
  <form class="w-full">
    <h2 class="py-4 text-2xl font-extrabold text-blue">Job Details</h2>
    <div class="flex flex-col gap-6 md:grid md:grid-cols-2">
      <div class="w-full">
        <label for="jobTitle" class="text-md font-extrabold text-grey-70"
          >Job title of Required Staff</label
        >
        <InputText
          class="rounded"
          name="jobTitle"
          required
          type="text"
          :value="jobTitle"
          :error="errors.hasOwnProperty('jobTitle')"
          :error-message="getErrorMessage('jobTitle')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'jobTitle',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="w-full">
        <label for="jobLocation" class="text-md font-extrabold text-grey-70"
          >Job location</label
        >
        <InputText
          class="rounded"
          name="jobLocation"
          type="text"
          required
          :value="jobLocation"
          :error="errors.hasOwnProperty('jobLocation')"
          :error-message="getErrorMessage('jobLocation')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'jobLocation',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="w-full">
        <label for="employmentType" class="text-md font-extrabold text-grey-70"
          >Employment type</label
        >
        <InputDropdown
          input-classes="w-full rounded"
          name="employmentType"
          placeholder="Employment type"
          :disable-error-popup="true"
          :searchable="false"
          :error="errors.hasOwnProperty('employmentType')"
          :error-message="getErrorMessage('employmentType')"
          :items="employmentTypeOptions"
          :value="employmentType"
          @change="
            (value) =>
              this.$emit('changeParameter', { key: 'employmentType', value })
          "
        />
      </div>
      <div class="md:col-span-2">
        <HorizontalSeparator class="border-grey-60 py-2" />
        <h2 class="text-2xl font-extrabold text-blue">Contact Details</h2>
      </div>
      <div class="w-full">
        <label for="companyName" class="text-md font-extrabold text-grey-70"
          >Company name</label
        >
        <InputText
          class="rounded"
          name="companyName"
          type="text"
          required
          :value="companyName"
          :error="errors.hasOwnProperty('companyName')"
          :error-message="getErrorMessage('companyName')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'companyName',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="w-full">
        <label for="contactName" class="text-md font-extrabold text-grey-70"
          >Contact Name</label
        >
        <InputText
          class="rounded"
          name="contactName"
          type="text"
          required
          :value="contactName"
          :error="errors.hasOwnProperty('contactName')"
          :error-message="getErrorMessage('contactName')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'contactName',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="w-full">
        <label for="email" class="text-md font-extrabold text-grey-70"
          >Email Address</label
        >
        <InputText
          class="rounded"
          name="email"
          type="text"
          required
          :value="email"
          :error="errors.hasOwnProperty('email')"
          :error-message="getErrorMessage('email')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'email',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="w-full">
        <label for="phoneNumber" class="text-md font-extrabold text-grey-70"
          >Phone number</label
        >
        <InputText
          class="rounded"
          name="phoneNumber"
          type="text"
          required
          :value="phoneNumber"
          :error="errors.hasOwnProperty('phoneNumber')"
          :error-message="getErrorMessage('phoneNumber')"
          @change="
            (event) =>
              this.$emit('changeParameter', {
                key: 'phoneNumber',
                value: event.target.value,
              })
          "
        />
      </div>
      <div class="col-span-2 w-full">
        <label
          for="contactOtherAgencies"
          class="text-md block font-extrabold text-grey-70"
        >
          <input
            type="checkbox"
            id="contactOtherAgencies"
            name="contactOtherAgencies"
            :checked="this.contactOtherAgencies"
            @change.prevent="
              () =>
                this.$emit('changeParameter', {
                  key: 'contactOtherAgencies',
                  value: !this.contactOtherAgencies,
                })
            "
          />
          Please send my job details to one or two additional agencies that
          recruit for my requirement
        </label>
      </div>
      <div class="col-span-2 mt-4 w-full">
        <InputButton
          class="rounded"
          @onClick="this.$emit('submit')"
          styleType="primary"
          :disabled="submitting"
        >
          Send Requirements
        </InputButton>
      </div>
    </div>
  </form>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import InputDropdown from 'Components/InputDropdown.vue';
import HorizontalSeparator from 'Components/HorizontalSeparator';
import InputFile from 'Components/InputFile';
import InputTextArea from 'Components/InputTextArea';
import InputText from 'Components/InputText.vue';

export default {
  name: 'EmployerCallbackForm',
  components: {
    HorizontalSeparator,
    InputTextArea,
    InputFile,
    InputButton,
    InputText,
    InputDropdown,
  },
  props: {
    jobTitle: {
      type: String,
      default: '',
    },
    jobLocation: {
      type: String,
      default: '',
    },
    employmentType: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      default: '',
    },
    contactName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    contactOtherAgencies: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: {},
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employmentTypeOptions: {
        any: 'All',
        contract: 'Contract Position',
        permanent: 'Permanent Position',
        temptoperm: 'Temp To Perm',
        temp: 'Temporary Position',
        parttime: 'Part Time Position',
      },
    };
  },
  methods: {
    getErrorMessage(key) {
      if (
        !this.errors.hasOwnProperty(key) ||
        !this.errors[key] instanceof Array
      ) {
        return;
      }
      // Errors returned by the API is a list of strings for each validation failed. Join the validation messages
      // together into a single string.
      return this.errors[key].join(' ');
    },
  },
};
</script>
